module.exports = __webpack_public_path__ + "static/media/OPS.7dcc1e5e.png";